function createEventId() {
  const bytes = new Uint8Array(16);

  if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  bytes[6] = (bytes[6] % 16) + 64;
  bytes[8] = (bytes[8] % 64) + 128;

  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0'));

  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
}

function createTosEvent({
  checked,
  context,
  invoiceId = null,
  token = null,
}) {
  const event = {
    event_id: createEventId(),
    checked: !!checked,
    context,
    occurred_at: new Date().toISOString(),
  };

  if (invoiceId !== null && typeof invoiceId !== 'undefined') {
    event.invoice_id = invoiceId;
  }

  if (token) {
    event.token = token;
  }

  return event;
}

export function recordTosDecision({
  api,
  store,
  checked,
  context,
  invoiceId = null,
  token = null,
}) {
  const event = createTosEvent({
    checked,
    context,
    invoiceId,
    token,
  });
  const authenticated = !!(
    store.state.user
    && store.state.user.auth_token
  );

  if (authenticated || token) {
    return api.post('partner/payment/tos-acceptance', event).then((response) => {
      if (!response.data || response.data.logged !== true) {
        store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'Your Terms of Service selection could not be logged. Please try again.',
        });
        throw new Error('The Terms of Service event was not logged.');
      }
      return response;
    });
  }

  return store.dispatch('queueTosAcceptance', event);
}

export async function flushPendingTosAcceptances({
  api,
  store,
  authToken,
}) {
  if (!authToken) {
    throw new Error('An authenticated user is required to log Terms of Service events.');
  }

  const pendingEvents = await store.dispatch('getPendingTosAcceptances');
  const encodedAuthToken = window.btoa(authToken);

  for (let index = 0; index < pendingEvents.length; index += 1) {
    const event = pendingEvents[index];
    const eventPayload = { ...event };
    delete eventPayload.expires_at;
    delete eventPayload.origin_brand;

    // Keep the same event_id until the server accepts it. This makes a retry
    // safe if the response is lost after the audit has already been written.
    // eslint-disable-next-line no-await-in-loop
    const response = await api.post('customer/payment/tos-acceptance', {
      ...eventPayload,
      auth_token: encodedAuthToken,
    }, {
      headers: {
        Authorization: `Basic ${encodedAuthToken}`,
      },
      preserveTosQueueOnUnauthorized: true,
    });

    if (!response.data || response.data.logged !== true) {
      store.dispatch('addAlert', {
        id: Date.now(),
        type: 'error',
        message: 'Your Terms of Service selection could not be logged. Please try again.',
      });
      throw new Error('The Terms of Service event was not logged.');
    }

    // eslint-disable-next-line no-await-in-loop
    await store.dispatch('removePendingTosAcceptance', event.event_id);
  }
}
